import { LoadingPage, ResponsiveMenuLayout, Typography } from "@fideus-ui/core";
import { type ReactNode, Suspense } from "react";
import { useTranslation } from "../_app/i18n";
import { TaxAdvisorMenu } from "./TaxAdvisorMenu";
import { translations } from "./translations";

export function TaxAdvisorLayout({
  children,
  topBar,
}: {
  children: ReactNode;
  topBar?: ReactNode;
}) {
  const t = useTranslation(translations);

  return (
    <ResponsiveMenuLayout
      title={<Typography variant="h4">{t("title")}</Typography>}
      topBar={topBar}
      menu={<TaxAdvisorMenu />}
      titleInverted={t("title")}
    >
      <Suspense fallback={<LoadingPage />}>{children}</Suspense>
    </ResponsiveMenuLayout>
  );
}
